import IMask from 'imask';
import { formatCpf, formatCnpj } from '@brazilian-utils/formatters';

export { formatCpf };

export { formatCnpj };

export const removeExtension = (filename) => {
  const split = filename.split('.');
  return split.slice(0, -1).join('');
};

export const removeDiacritics = (str) => str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

export const namify = (str) => removeDiacritics(str.trim().toLowerCase().replace(/[^a-zA-Z0-9 -]/, '').replace(/\s/g, '-'));

export const getFilenameFromUrl = (url) => {
  const split = url.split('/');
  return split[split.length - 1];
};

export const unformatNumber = (value = '') => String(value).replace(/\D/g, '');

export const formatPhone = (value = '') => {
  const phoneMask = IMask.createMask({ mask: '(00) 0000-0000' });
  const mobileMask = IMask.createMask({ mask: '(00) 00000-0000' });

  const unformated = unformatNumber(value);
  const firstChar = unformated.slice(2).charAt(0);

  if (firstChar === '9') {
    return mobileMask.resolve(unformatNumber(unformated));
  }

  return phoneMask.resolve(unformatNumber(unformated));
};

export const formatCpfCnpj = (value = '') => {
  const unformated = unformatNumber(value);

  if (unformated.length < 12) {
    return formatCpf(unformated);
  }

  return formatCnpj(unformated);
};

export const formatCep = (value = '') => {
  const cepMask = IMask.createMask({ mask: '00000-000' });
  const unformated = unformatNumber(value);
  return cepMask.resolve(unformated);
};

const getDifferentChar = (oldValue, value) => {
  for (let i = 0; i < value.length; i += 1) {
    if (value[i] !== oldValue[i]) {
      return value[i];
    }
  }

  return null;
};

const LOCALE = 'pt-br';
const CURRENCY = 'BRL';
const PRECISION = 2;

export const unformatMoney = (val, precision = 2) => {
  let value = typeof val === 'number'
    ? String(val.toFixed(precision))
    : val.replace(/\D/g, '');

  if (val.length < precision) {
    value = `0.${Array(precision - val.length).fill().map(() => '0').join('')}${value}`;
  }

  else {
    value = `${value.slice(0, -precision)}.${value.slice(-precision)}`;
  }

  return parseFloat(value, 10);
};

export const formatMoney = (v, ov) => {
  const value = typeof v === 'number' ? v.toFixed(2) : v;
  const oldValue = typeof ov === 'number' ? ov.toFixed(2) : ov;

  // user cleared the input
  if (value === '') {
    return '';
  }

  let monetaryValue = unformatMoney(value.replace(/\D/g, ''), PRECISION);

  if (oldValue || parseInt(oldValue, 10) === 0) {
    const strippedOld = oldValue.replace(/\D/g, '');
    const strippedVal = value.replace(/\D/g, '');

    if (strippedOld.length > strippedVal.length) {
      monetaryValue = unformatMoney(strippedVal, PRECISION);
    }

    else {
      const newChar = getDifferentChar(strippedOld, strippedVal);

      if (newChar !== null || /\d/.test(newChar)) {
        const oldVal = parseInt(strippedOld, 10);
        monetaryValue = unformatMoney(`${oldVal}${newChar}`, PRECISION);
      }
    }
  }

  return monetaryValue.toLocaleString(LOCALE, {
    style: 'currency',
    currency: CURRENCY,
    minimumFractionDigits: PRECISION,
    maximumFractionDigits: PRECISION,
  });
};
